var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/iframe.ts
import "@adornis/buildify/client/components/x-buildify-color-picker";
import "@adornis/buildify/client/components/x-buildify-spacing-picker";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/forms/x-checkbox.js";
import "@adornis/forms/x-input";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { IFRAME_KEY, IFRAME_SCHEMA } from "../../schema/nodes/iframe.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import "../types.js";
import { isNodeSelection } from "../util.js";
var editor = ({ content, contentController, controllerBaseKeyPath, host }) => {
  return html`
    <x-flex space="md">
      <x-input placeholder="Url*" ${contentController.field(...controllerBaseKeyPath, "url")}></x-input>
      <x-input placeholder="Höhe" ${contentController.field(...controllerBaseKeyPath, "height")}></x-input>
    </x-flex>
  `;
};
var iframe = () => ({
  node: {
    name: IFRAME_KEY,
    schema: IFRAME_SCHEMA()
  },
  menuItems: [
    {
      label: "iFrame",
      icon: "frame_inspect",
      run: (view) => runInsertNode(IFRAME_KEY)(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
});
var NodeIframe = class extends BuildifyLitElement {
  content({ content, mode }) {
    return html` <iframe ${css({ width: "100%", height: content.height ?? "500px" })} src=${content.url}></iframe> `;
  }
};
NodeIframe = __decorateClass([
  customElement("node-iframe")
], NodeIframe);
export {
  NodeIframe,
  editor,
  iframe
};
